import React from "react";
import "./Mission.css";
export default function Mission() {
  return (
    <section className="mission-section">
      <div className="mission-left">
        <h2>Who We Are ?</h2>
        <p>
          RISEN STAR GOODS is a global wholesale leader specializing in premium
          food products and commodities, including frozen chicken, rice, spices,
          and essential goods. We partner with certified producers worldwide to
          deliver quality-assured products through our robust supply chain
          network. Serving markets across the Middle East, Asia, and Africa, we
          maintain our reputation through ethical sourcing, reliable delivery,
          and unwavering commitment to excellence in international trade.
        </p>
      </div>

      <div className="mission-right">
        <h3>Our Mission:</h3>
        <p>
          We are committed to enhancing global food security by providing
          superior-quality products through sustainable and transparent trade
          practices. Our mission focuses on building lasting partnerships,
          ensuring consistent supply chain efficiency, and delivering
          exceptional value to customers worldwide. Driven by integrity and
          innovation, we strive to set industry benchmarks while meeting the
          evolving needs of international markets.
        </p>
      </div>
    </section>
  );
}
